module.exports = __webpack_public_path__ + "img/unit_BlueMetallic.d3def876.png";